import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrackingPointComponent } from './tracking-point/tracking-point.component';
import { RouterModule } from '@angular/router';
// import { MatSliderModule } from '@angular/material/slider';
import { ChipsModule } from "primeng/chips";
import { ButtonModule } from "primeng/button";
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import {AccordionModule} from 'primeng/accordion';
import { ChipModule } from 'primeng/chip';
import { TrackingService } from './tracking.service';

export const routes = [
  { path: '', component: TrackingPointComponent},
];

@NgModule({
  declarations: [TrackingPointComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    // MatSliderModule,
    ChipsModule,
    ButtonModule,
    BrowserModule,
    FormsModule,
    AccordionModule,
    ChipModule
  ]
})
export class TrackingModule {
  static routes = routes;
}
